var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Buttons',{attrs:{"layout":"stretch"}},[_c('RuButton',{attrs:{"href":_vm.action.link,"level":"primary"}},[_vm._v("\n    "+_vm._s(_vm.action.text)+"\n    "),_c('Icon',{attrs:{"id":"arrow-right"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }